<template>
  <n-config-provider :theme="theme" class="w-full h-screen t-0 l-0 m-0 p-0 ">
    <n-message-provider>
      <n-dialog-provider>
        <n-modal-provider>
          <router-view>

          </router-view>
        </n-modal-provider>
      </n-dialog-provider>


    </n-message-provider>

  </n-config-provider>


</template>

<script>
import { darkTheme, lightTheme } from 'naive-ui'

const themeOverrides = {
  common: {
    primaryColor: '#FF0000'
  },
  Button: {
    textColor: '#FF0000'
  },
  Select: {
    peers: {
      InternalSelection: {
        textColor: '#FF0000'
      }
    }
  }
}

export default {
  name: 'App',
  components: {

  },
  data() {
    return {
      routerPath: "",
      activeKey: "square",
      theme: darkTheme,

      myTheme: "light",
    };
  },
}
</script>

<style>
#app {
  width: 100%;
  height: 100%;
  padding: 0;
  margin: 0;
  border: 0;
}
</style>
